import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/recommended-foods"

export const getRecommendedFoods = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const addRecommendedFoods = async (data) => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const updateRecommendedFoods = async (recommendedFoodId, data) => {
  const response = await farasod.post(`${endpoint}/${recommendedFoodId}`, data)

  return response.data
}

export const deleteRecommendedFoods = async (recommendedFoodId) => {
  const response = await farasod.patch(`${endpoint}/${recommendedFoodId}`)

  return response.data
}